<template>
  <div>
    <div class="head" :style="{top: getTopWithNavBarHeight(45)}">
      <div class="previous">
        <img v-if="currentRunIndex > 0" @click="itemHandleBlock(currentRunIndex - 1)" src="~@/assets/football/schedule/btn_previous.png"/>
      </div>
      <div class="roundDiv">
        <span @click="actionSheetShowState = true" class="round">{{currentRunStr}}</span>
      </div>
      <div class="next">
        <img v-if="currentRunIndex + 1 < this.allRunStr.length" @click="itemHandleBlock(currentRunIndex + 1)" src="~@/assets/football/schedule/btn_next.png"/>
      </div>
    </div>
    <div class="section" v-for="(group, groupIndex) in groupList" :key="groupIndex">
      <div class="line" v-if="groupIndex > 0 && leagueType == 2"></div>
      <div class="sectionTitle" v-if="leagueType == 2 && group.groupName.length > 0" @click="handleTitle(groupIndex)">
        <span>{{group.groupName}}</span>
        <img :src="group.isShow ? require('@/assets/football/schedule/btn_hiddenround.png') : require('@/assets/football/schedule/btn_openround.png')"/>
        </div>
      <div v-if="group.isShow">
        <template v-for="(match, index) in group.matchList">
          <hr :key="index + 100" v-if="index == 0 && group.groupName.length > 0"/>
          <ftmatchcell :match="match" :key="index + 1000"></ftmatchcell>
          <hr :key="index + 10000" v-if="index < group.matchList.length - 1"/>
        </template>
      </div>
    </div>
    <actionSheet v-show="actionSheetShowState"
      :isShow='actionSheetShowState'
      :options='allRunStr'
      :currentOption='currentRunIndex'
      @close='actionSheetShowState = false'
      @selected="itemHandleBlock($event)"/>
    <loadStateView :state="netState" :refreshHandle="refreshData"/>
  </div>
</template>

<script>
import ftmatchcell from '../components/matchcell'
import actionSheet from '@/components/ActionSheet'

export default {
  name: 'matches',
  components: {
    ftmatchcell,
    actionSheet
  },
  activated () {
    if (this.$route.params.yearForRoute && this.$route.params.yearForRoute.length > 0) {
      this.year = this.$route.params.yearForRoute
    } else {
      this.loadData()
    }
  },
  watch: {
    year (newValue) {
      if (newValue.length > 0) {
        this.loadDataWithYear()
      } else {
        this.loadData()
      }
    },
    fixtureData (newValue) {
      this.computedData(this.fixtureData)
    }
  },
  props: {
    yearForRoute: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      currentRunStr: '',
      currentRunIndex: 0,
      allRun: [],
      allRunStr: [],
      groupList: [],
      allRunMatchList: [],
      actionSheetShowState: false,
      year: this.yearForRoute,
      fixtureData: null,
      leagueType: 0, // 1联赛，2杯赛
      netState: 0
    }
  },
  methods: {
    loadData: function () {
      this.netState = this.groupList.length > 0 ? 0 : 1
      this.$ft_getLeagueFixture(this.$route.params.leagueId).then(result => {
        this.leagueType = result.type
        this.computedData(result)
      }).catch((error) => {
        this.netState = this.groupList.length > 0 ? 0 : 2
        console.log('error:', error)
      })
    },
    loadDataWithYear: function () {
      this.netState = this.groupList.length > 0 ? 0 : 1
      this.$ft_getFixtureByYear(this.$route.params.leagueId, this.year, this.leagueType).then(result => {
        this.leagueType = result.type
        this.computedData(result)
      }).catch((error) => {
        this.netState = this.groupList.length > 0 ? 0 : 2
        console.log('error:', error)
      })
    },
    refreshData: function () {
      if (this.year.length > 0) {
        this.loadDataWithYear()
      } else {
        this.loadData()
      }
    },
    computedData: function (result) {
      this.netState = result.netState
      var newAllRun = []
      if (this.leagueType === 1) {
        for (var i in result.allRun) {
          if (parseInt(this.$route.params.leagueId) === 107) { // 美职联特殊处理，老webview的逻辑
            newAllRun.push(result.allRun[i] + this.$t('common.mounth'))
          } else {
            newAllRun.push(this.$t('scheduleNotesTitle.runTitle') + result.allRun[i] + this.$t('scheduleNotesTitle.runTitle1'))
          }
        }
      } else {
        newAllRun = result.allRun
      }

      this.allRun = result.allRun
      this.allRunStr = newAllRun
      this.currentRunIndex = this.allRun.findIndex((e) => e === result.currentRun)
      if (this.currentRunIndex < 0) {
        this.currentRunIndex = this.leagueType === 1 ? result.currentRun - 1 : result.currentRun
      }
      this.currentRunStr = this.allRunStr[this.currentRunIndex]

      this.allRunMatchList = result.fixture
      this.filterMatchesWithRun(result)
    },
    // 根据当前轮次筛选出对应比赛
    filterMatchesWithRun: function (result) {
      if (this.leagueType === 1) {
        this.filterLeagueData(result)
      } else {
        this.filterCupData(result)
      }
    },
    filterCupData: function (result) { // 处理杯赛数据
      var currentRunMatchList = []
      var allGroup = [] // 当前轮所有小组名
      var matchListWithGroup = [] // 根据小组名分组的比赛列表
      // console.log('current: ' + currentRunIndex + ' allRun: ' + this.allRun.length)
      this.allRunMatchList.forEach((item, index) => {
        if (parseInt(item.run) === parseInt(this.currentRunIndex)) {
          currentRunMatchList.push(item)
          // 判断当前比赛小组名是否已有
          if (allGroup.length > 0) {
            var ret = allGroup.findIndex((value, index, arr) => {
              return value === item.group
            })
            if (ret < 0) {
              allGroup.push(item.group)
            }
          } else {
            allGroup.push(item.group)
          }
        }
      })

      allGroup.forEach(function (item, index) {
        var matchList = []
        currentRunMatchList.forEach(function (match, index) {
          // console.log('i: ' + item + 'm:' + match.group)
          if (item === match.group) {
            matchList.push(match.game)
          }
        })
        matchListWithGroup.push({ groupName: item, matchList: matchList, isShow: index === 0 })
      })
      this.groupList = matchListWithGroup
      this.netState = this.groupList.length > 0 ? 0 : result.netState
    },
    filterLeagueData: function (result) { // 处理联赛数据
      var currentRunMatchList = []
      var currentRun = this.allRun[this.currentRunIndex]
      this.allRunMatchList.forEach(function (item, index) {
        if (parseInt(item.run) === parseInt(currentRun)) {
          currentRunMatchList.push(item.game)
        }
      })

      var matchListWithGroup = [{ groupName: '', matchList: currentRunMatchList, isShow: true }] // 根据小组名分组的比赛列表
      this.groupList = matchListWithGroup
      this.netState = this.groupList.length > 0 ? 0 : result.netState
    },
    itemHandleBlock: function (index) {
      if (index >= this.allRunStr.length) return
      this.currentRunIndex = index
      this.currentRunStr = this.allRunStr[index]
      this.filterMatchesWithRun()
    },
    getTopWithNavBarHeight: function (top) {
      return (top + parseInt(this.$route.params.NavBarHeight)) + 'px'
    },
    handleTitle: function (index) {
      if (this.leagueType === 2) {
        this.groupList[index].isShow = !this.groupList[index].isShow
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "style"
</style>
